import { freezeProductBulkSelection } from "./product-bulk-selection.js";
import { MERCHANT_OPERATIONS } from "@price-rescue/api-contracts";
import type { MerchantApiClient } from "../../types.js";
import type { ProductRow } from "./models.js";

export interface EligibilityResetIssue {
  productId: string;
  code: string;
  message: string;
}
export interface EligibilityResetResult {
  previews: { productId: string; current: ProductRow; resulting: ProductRow }[];
  updated: ProductRow[];
  failed: EligibilityResetIssue[];
  skipped: EligibilityResetIssue[];
  unconfirmed?: EligibilityResetIssue[];
}
export interface EligibilityResetService {
  preview(productIds: string[]): Promise<EligibilityResetResult>;
  execute(productIds: string[]): Promise<EligibilityResetResult>;
}
export function createEligibilityResetService(client: MerchantApiClient): EligibilityResetService {
  async function request(productIds: string[], preview: boolean): Promise<EligibilityResetResult> {
    const response = await client.operation<{ data: EligibilityResetResult }>(
      preview
        ? MERCHANT_OPERATIONS.previewCatalogProductEligibilityReset
        : MERCHANT_OPERATIONS.resetCatalogProductEligibilityBulk,
      {
        body: { productIds: freezeProductBulkSelection(productIds) },
        request: { idempotencyKey: globalThis.crypto.randomUUID() },
      },
    );
    return response.data;
  }
  return {
    preview: (ids) => request(ids, true),
    execute: (ids) => request(ids, false),
  };
}
